module.exports = __webpack_public_path__ + "media/images/brand/img-jewelry2-4bdd13bcdba6d64fbeb820987d73e33c.png";